import { Component, OnInit } from '@angular/core';
import { AutocompleteNode } from 'src/app/ceq/common/ceq-unit-autocomplete/ceq-unit-autocomplete.component';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { ProductService } from '../../product.service';
import { SingleResponseJson } from 'src/app/ceq/common/models/response';

@Component({
  selector: 'app-cut-pt-report',
  templateUrl: './cut-pt-report.component.html',
  styleUrls: ['./cut-pt-report.component.scss']
})
export class CutPtReportComponent implements OnInit {

  constructor(
    private globalService: GlobalFunctionsService,
    private productService: ProductService,
  ) { }

  working: boolean = false;

  //filters
  startDate: string;
  endDate: string;
  maxDate: string;
  resalta: boolean = false;

  //Filters
  selectedUnit: AutocompleteNode = undefined;

  ngOnInit(): void {
    this.startDate = this.globalService.getStringDate(new Date(), false, 0);
    this.endDate = this.globalService.getStringDate(new Date(), false, 0);
    this.maxDate = this.globalService.getStringDate(new Date(), true, -3);
  }

  onUnitClear() {
    this.selectedUnit = undefined;
  }

  async onUnitSelected(event: AutocompleteNode) {
    this.selectedUnit = event;
  }


  onStartDateSelected() {
    if (new Date(this.startDate) > new Date(this.endDate)) {
      this.endDate = this.startDate
    }
  }

  onEndDateSelected() {
    if (new Date(this.startDate) > new Date(this.endDate)) {
      this.startDate = this.endDate
    }
  }
  

  async Download() {

    let maxDaysRange: number = 62;
    var diff = Math.abs(new Date(this.endDate).getTime() - new Date(this.startDate).getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    if (diffDays >= maxDaysRange) {
      this.globalService.messageToast(`El rango de fechas no puede ser mayor a ${maxDaysRange} días.`, 'error');
      return;
    }

    this.working = true;
    await this.globalService.messageToast("Descargando Archivo", 'loading');

    if (this.selectedUnit == undefined) {
      this.selectedUnit = { UnitId: 0, UnitDescription: 'Todos', UnitOrgId: 0, ParentId: 0, UnitCode: '', LevelType: '', }
    }
    const request: any = {
      Args: {
        EndDate: this.endDate,
        StartDate: this.startDate,
        UnitId: this.selectedUnit.UnitId
      }
    }

    await this.productService.genCutPTReport(request).toPromise().then(async (resp: SingleResponseJson<string>) => {
      if (resp && resp.Success) {
        this.working = false;
        const downloadLink = document.createElement('a');
        const fileName = `CompulsaPT-${this.selectedUnit.UnitId == 0?"Todos":this.selectedUnit.UnitDescription}.xlsx`;

        downloadLink.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + resp.Response;
        downloadLink.download = fileName;
        downloadLink.click();
        await this.globalService.messageToast("Archivo Descargado", 'success');
      } else {
        this.working = false;
        await this.globalService.messageToast("Archivo no fue posible generarlo", 'error');
        console.log(resp.Error_msg);
      }
    })
    .catch(async (error) => {
      this.working = false;
      console.error(error);
      await this.globalService.messageToast(error.error.Message, 'error');
    });
  }

}